import { Component, OnInit } from '@angular/core';
import { environment } from 'src/environments/environment';
import { register } from 'swiper/element/bundle';
import { AppUpdateService } from './core/services/app-update.service';
register();

type WindowWithInitMap = Window & { initMap?: () => void };

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    standalone: false
})
export class AppComponent implements OnInit {
  constructor(private readonly appUpdateService: AppUpdateService) {}

  ngOnInit() {
    // Create the script tag, set the appropriate attributes
    const script = document.createElement('script');
    script.src = `https://maps.googleapis.com/maps/api/js?key=${environment.googleApiKey}&libraries=visualization&callback=initMap&loading=async`;
    script.async = true;

    (window as WindowWithInitMap).initMap = function () {
      // JS API is loaded and available
    };

    // Append the 'script' element to 'head'
    document.head.appendChild(script);

    this.appUpdateService.init();
  }
}
